// extracted by mini-css-extract-plugin
module.exports = {"listingPage":"SearchArticles_listingPage___gSu9","articles":"SearchArticles_articles___p7FF"};